export const DEFAULT_MODULE_LENGTH = 5;
